import { render, staticRenderFns } from "./AdminOrders.vue?vue&type=template&id=3acfe70b&scoped=true&"
import script from "./AdminOrders.vue?vue&type=script&lang=js&"
export * from "./AdminOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3acfe70b",
  null
  
)

export default component.exports